import { getTrimTypeForConnectionAngle } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const convertToCornerTrimMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Convert to Corner Trim',
		isVisible: ({ controller, refMap }): boolean => {
			const { panelTrim } = refMap ?? {};
			if (controller?.readonly || !panelTrim) return false;

			return panelTrim.isFlat;
		},
		onClick: ({ refMap }): void => {
			const { panelTrim } = refMap ?? {};
			if (!panelTrim) return;

			const { panels, refMap: trimRefMap } = panelTrim;
			const { island } = trimRefMap ?? {};
			const [firstId = null] = panels ?? [];
			const panel = island?.panels?.findById(firstId) ?? null;

			panelTrim.setTrimTypePaired(getTrimTypeForConnectionAngle(panel?.connections?.left?.angle ?? null));
		}
	};
};
